import type { MakeModelOption, Filters } from './MakeModelKeywordSearch.typed';

/**
 * @param args filter values to be included in search payload
 * @returns autocomplete options, error state and loading state due to network requests
 */
export const useMakeModelKeywordSearch = (_args: Filters) => {
  // TODO: Add query: https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=board/5702367192831126523&appConfig=eyJhY2lkIjoiNTY1MTY2MDA0MDAzMEM2ODA3MURCQjQ5M0Y4NDQxQ0MifQ==&boardPopup=userstory/111840/silent
  const isPending = false;

  const data: Array<MakeModelOption> = [
    {
      value: { make: 'Volkswagen' },
      count: '10,000',
      label: 'Volkswagen',
    },
    {
      value: { make: 'Volkswagen', model: 'Golf' },
      count: '7,000',
      label: 'Volkswagen Golf',
    },
    {
      value: { make: 'Volkswagen', model: 'Polo' },
      count: '3,000',
      label: 'Volkswagen Polo',
    },
  ];

  const isError = false;

  return {
    isPending,
    data,
    isError,
  };
};
